declare global {
  interface Window {
    fbq: (...args: any[]) => void & {
      callMethod?: (...args: any[]) => void
      queue: any[]
      loaded: boolean
      version: string
    }
    _fbq: any
  }
}

const PIXEL_ID = '662740706921819'
let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  if (window.fbq) {
    // Script already loaded externally, just init the pixel
    window.fbq('init', PIXEL_ID)
    return
  }

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script') as HTMLScriptElement
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  window.fbq('init', PIXEL_ID)
}

// Only fires image pixel if fbevents.js hasn't fully loaded yet (no callMethod)
// This prevents duplicates when the script loads, but ensures delivery when it doesn't
function firePixelIfNeeded(eventName: string, params?: Record<string, any>) {
  if (typeof window === 'undefined') return

  // If fbq.callMethod exists, the real fbevents.js loaded — fbq() already handled it
  if (window.fbq && window.fbq.callMethod) return

  try {
    const queryParams = new URLSearchParams({
      id: PIXEL_ID,
      ev: eventName,
      noscript: '1',
    })

    if (params) {
      queryParams.set('cd[content_name]', params.content_name || '')
      queryParams.set('cd[content_type]', params.content_type || '')
      queryParams.set('cd[value]', String(params.value || ''))
      queryParams.set('cd[currency]', params.currency || 'USD')
      if (params.num_items) {
        queryParams.set('cd[num_items]', String(params.num_items))
      }
    }

    const url = `https://www.facebook.com/tr?${queryParams.toString()}`

    if (navigator.sendBeacon) {
      navigator.sendBeacon(url)
    } else {
      const img = new Image(1, 1)
      img.src = url
    }
  } catch (_) {
    // Silent fail
  }
}

function ensurePixelReady() {
  if (!initialized) initMetaPixel()
}

export function trackPageView() {
  ensurePixelReady()
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
  firePixelIfNeeded('PageView')
}

const ADD_TO_CART_PARAMS = {
  content_name: '$56 Más No Te Salva - Plan Anti-Ahogos 14 Días',
  content_type: 'product',
  value: 6.39,
  currency: 'USD',
}

export function trackAddToCart() {
  ensurePixelReady()
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', ADD_TO_CART_PARAMS)
  }
  firePixelIfNeeded('AddToCart', ADD_TO_CART_PARAMS)
}

export function trackInitiateCheckout() {
  ensurePixelReady()
  const params = { ...ADD_TO_CART_PARAMS, num_items: 1 }
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', params)
  }
  firePixelIfNeeded('InitiateCheckout', params)
}
